import { useEffect, useRef } from "react"
import { createPortal } from "react-dom"
import { PopupProps } from "./types"

import popupStyle from "./index.module.css"
import cx from "classix"

export type { PopupProps }

export function Popup({
						  style,
						  className,
						  children,
						  show = false,
						  position = "top",
						  targetElementRef,
						  colorStyle = "info",
						  ...props
					  }: PopupProps) {

	const divElRef = useRef<HTMLDivElement>(null)

	const update = () => {
		if (!targetElementRef?.current || !divElRef.current) return

		const targetRect = targetElementRef.current.getBoundingClientRect()

		const divWidth = divElRef.current.clientWidth
		const divHeight = divElRef.current.clientHeight

		const scrollX = window.scrollX
		const scrollY = window.scrollY

		if (position === "bottom") {
			divElRef.current.style.left = `${targetRect.left + (targetRect.width - divWidth) * 0.5 + scrollX}px`
			divElRef.current.style.top = `${targetRect.bottom + scrollY}px`
		} else if (position === "top") {
			divElRef.current.style.left = `${targetRect.left + (targetRect.width - divWidth) * 0.5 + scrollX}px`
			divElRef.current.style.top = `${targetRect.top - divHeight + scrollY}px`
		} else if (position === "left") {
			divElRef.current.style.left = `${targetRect.left - divWidth + scrollX}px`
			divElRef.current.style.top = `${targetRect.top + (targetRect.height - divHeight) * 0.5 + scrollY}px`
		} else if (position === "right") {
			divElRef.current.style.left = `${targetRect.right + scrollX}px`
			divElRef.current.style.top = `${targetRect.top + (targetRect.height - divHeight) * 0.5 + scrollY}px`
		}
	}

	useEffect(() => {
		if (!show) return;

		window.addEventListener("resize", update)
		window.addEventListener("scroll", update, true)

		update()

		return () => {
			window.removeEventListener("resize", update)
			window.removeEventListener("scroll", update, true)
		}
	}, [show, targetElementRef?.current, divElRef.current])


	const arrowEl = <div className={cx(popupStyle.arrow, popupStyle[position], popupStyle[colorStyle])} />
	const contentEl = <div className={cx(popupStyle.content, popupStyle[colorStyle])}>
		{children}
	</div>

	return createPortal(<div ref={divElRef}
							 style={style}
							 className={cx(popupStyle.popup, popupStyle[position], show && popupStyle.show, className)}
							 {...props}>
		{position === "top" || position === "left"
			? <>{contentEl}{arrowEl}</>
			: <>{arrowEl}{contentEl}</>
		}
	</div>, document.body)
}